import $ from 'jquery';
import { EdgeResizer } from '~src/utils';
import { applySelectedBlurBg } from './applySelectedBlurBg';
import { stopAiLoader } from '~core/aiLoader';
import axios from 'axios';
import axiosRetry from 'axios-retry';

const client = axios.create({
  timeout: 5000,
});

// Configure axios-retry
axiosRetry(client, {
  retries: 20,
  retryDelay: axiosRetry.exponentialDelay,
  validateStatus: (status) => status >= 200 && status < 400,
  shouldResetTimeout: true,
  retryCondition: () => {
    // Retry on any error
    return true;
  },
});

export function showBlurBgDialog(
  originalImageUrl,
  removebgImageUrl,
  startTime
) {
  // Clean up any existing modal and its event listeners
  const existingModal = $('#blurBgOptionsModal');
  if (existingModal.length) {
    existingModal.off('hidden.bs.modal');
    existingModal.modal('hide');
    existingModal.remove();
  }

  const blurLevels = [10, 20, 30, 40, 50];

  // Generate all composite URLs first
  const compositeUrls = blurLevels.map((blur) => {
    const edgeResizer = new EdgeResizer(originalImageUrl);
    edgeResizer.blur(blur);
    return {
      blur,
      compositeImageUrl: edgeResizer.composite(removebgImageUrl, 'over'),
    };
  });

  const edgeResizer = new EdgeResizer(originalImageUrl);
  edgeResizer.scaleToWidth(50);
  const lowResUrl = edgeResizer.blur(10);

  // Create and show the main modal immediately
  const modalHtml = `
    <div class="modal fade" id="blurBgOptionsModal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-xxl" role="document" style="max-width: 95vw;">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white">
            <h5 class="modal-title">Scegli l'intensità della sfocatura</h5>
            <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="max-height: 70vh; overflow-y: auto; padding: 25px;">
            <div class="d-flex justify-content-between flex-nowrap">
              ${compositeUrls
                .map(
                  ({ blur, compositeImageUrl }) => `
                <div class="px-3" style="flex: 1;">
                  <div class="card blur-option" 
                       data-blur="${blur}"
                       data-composite-url="${compositeImageUrl}"
                       style="cursor: pointer; height: 100%; border-radius: 8px; transition: transform 0.2s, box-shadow 0.2s;">
                    <div class="card-img-top" style="height: 450px; overflow: hidden; display: flex; align-items: center; justify-content: center; position: relative;">
                      <div class="image-protection-overlay"></div>
                      <img class="img-fluid protected-image" style="max-height: 100%; max-width: 100%; object-fit: contain; opacity: 0; transition: opacity 1.2s cubic-bezier(0.4, 0, 0.2, 1);" alt="Sfocatura ${blur}%">
                      <div class="ai-loader blur-loader" data-blur="${blur}" style="background-color: transparent;">
                        <img src="${lowResUrl}" style="position: absolute; top: 0; left: 0; width: 100%; height: auto; object-fit: scale-down; opacity: 0.8; z-index: 1; margin: auto; top: 50%; transform: translateY(-50%);">
                        <!-- Loading effect elements will be injected here -->
                      </div>
                      <!--<div class="blur-badge" style="position: absolute; bottom: 15px; right: 15px; z-index: 10; background-color: rgba(15, 23, 42, 0.75); color: white; font-weight: 400; font-size: 0.8rem; padding: 4px 8px; border-radius: 3px; display: flex; align-items: center; letter-spacing: 0.5px;">
                        <span style="display: inline-block; width: 6px; height: 6px; border-radius: 50%; background-color: rgba(0, 170, 255, 0.9); margin-right: 5px;"></span>
                        Sfocatura ${blur}%
                      </div>-->
                    </div>
                  </div>
                </div>
              `
                )
                .join('')}
            </div>
            <div class="row mt-3">
              <div class="col-12 text-center">
                <p class="text-muted">Seleziona un'immagine per applicare la sfocatura</p>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Annulla</button>
          </div>
        </div>
      </div>
    </div>
  `;

  // Add modal to body
  $('body').append(modalHtml);

  // Helper function to create particles
  function createParticles(container) {
    // Create particles
    const numParticles = 25; // Increased for more visual impact

    for (let i = 0; i < numParticles; i++) {
      const particle = document.createElement('div');
      particle.className = 'particle';

      // Random position
      const left = 10 + Math.random() * 80;
      const top = 60 + Math.random() * 40;

      particle.style.left = left + '%';
      particle.style.top = top + '%';

      // Random size (slightly increased for better visibility)
      const size = 2 + Math.random() * 4;
      particle.style.width = size + 'px';
      particle.style.height = size + 'px';

      // Random float direction
      const translateX = (Math.random() - 0.5) * 130;
      particle.style.setProperty('--translate-x', translateX + 'px');

      // Random animation delay
      const delay = Math.random() * 3;
      particle.style.animationDelay = delay + 's';
      // Random animation duration (for subtle variation)
      const duration = 2.2 + Math.random() * 1;
      particle.style.animationDuration = duration + 's';

      // Add to container
      container.appendChild(particle);
    }
  }

  // Function to initialize the loading effects
  function initBlurPreviewEffects() {
    // Get all loaders
    const loaders = document.querySelectorAll('.blur-loader');

    // Process each loader
    loaders.forEach((loader) => {
      // Add the effect elements
      loader.innerHTML = `
        <img src="${lowResUrl}" style="position: absolute; top: 0; left: 0; width: 100%; height: auto; object-fit: contain; opacity: 0.8; z-index: 1; margin: auto; top: 50%; transform: translateY(-50%);">
        <div class="noise" style="z-index: 2;"></div>
        <div class="grid-overlay" style="z-index: 2;"></div>
        <div class="hex-grid" style="z-index: 2;"></div>
        <div class="scanner" style="z-index: 3;"></div>
        <div class="particles" data-blur="${loader.dataset.blur}" style="z-index: 3;"></div>
        <div class="center-ring" style="z-index: 3;"></div>
      `;

      // Create the particles for this loader
      const particlesContainer = loader.querySelector('.particles');
      createParticles(particlesContainer);
    });
  }

  // Initialize the loading effects
  initBlurPreviewEffects();

  // Show modal immediately
  $('#blurBgOptionsModal').modal({
    backdrop: 'static',
    keyboard: true,
  });

  // Close the loader after modal is shown
  stopAiLoader();

  // Main function to fetch images and update UI as they become available
  const fetchAndDisplayImages = async () => {
    // Make all cards start with the glow effect
    $('.blur-option').addClass('loading');

    // Add a small delay before starting image fetching
    // sleep
    // await new Promise((resolve) => setTimeout(resolve, 10000));

    // Fetch all images in parallel, updating UI as each one completes
    const fetchPromises = compositeUrls.map(({ blur, compositeImageUrl }) => {
      return client
        .get(compositeImageUrl)
        .then(() => {
          const card = $(`.blur-option[data-blur="${blur}"]`);
          const img = card.find('img');
          const loader = card.find('.blur-loader');

          // Load the image
          img.on('load', function () {
            // First fade out the loader
            loader.css('opacity', 0);

            // Then fade in the image with a slight delay for smoother transition
            setTimeout(() => {
              img.css('opacity', 1);
              card.removeClass('loading glow').addClass('loaded');

              // Completely hide the loader after the fade out
              setTimeout(() => {
                loader.css('display', 'none');
              }, 1000);
            }, 300);
          });

          // Set src after binding load event
          img.attr('src', compositeImageUrl);
        })
        .catch(() => {
          const card = $(`.blur-option[data-blur="${blur}"]`);
          card.removeClass('loading glow').addClass('error');
          card
            .find('.card-img-top')
            .append(
              '<div class="position-absolute w-100 text-center" style="bottom: 0; background-color: rgba(220, 53, 69, 0.85); color: white; padding: 10px; z-index: 10;"><i class="fas fa-exclamation-triangle mr-2"></i>Errore nel caricamento</div>'
            );
        });
    });

    // Wait for all fetch operations to complete (success or failure)
    await Promise.allSettled(fetchPromises);
  };

  // Handle click on blur option
  const setupEventHandlers = () => {
    $('.blur-option').on('click', function () {
      // Only allow clicking on successfully loaded images
      if ($(this).hasClass('error') || $(this).hasClass('loading')) {
        return;
      }

      // Add highlight effect to selected card
      $('.blur-option').removeClass('selected');
      $(this).addClass('selected');

      const compositeUrl = $(this).data('composite-url');
      const blurLevel = $(this).data('blur');
      $('#blurBgOptionsModal').modal('hide');

      // Clean up
      $('#blurBgOptionsModal').on('hidden.bs.modal', function () {
        $(this).remove();
        $('.modal-backdrop').remove();
        $('body').removeClass('modal-open');
        applySelectedBlurBg(
          originalImageUrl,
          compositeUrl,
          startTime,
          blurLevel
        );
      });
    });
  };

  // Initialize the process
  fetchAndDisplayImages()
    .then(() => {
      setupEventHandlers();
    })
    .catch((error) => {
      console.error('Failed to initialize image prefetching:', error);
    });
}
